import { Size } from "@yfiles/yfiles"

const IMAGES = "assets/images/"

export const GREEN_CIRCLE = IMAGES + "green-circle.svg"
export const RED_CIRCLE = IMAGES + "red-circle.svg"

export const GREEN_DOWN_ARROW = IMAGES + "green-arrow-down.png"
export const RED_UP_ARROW = IMAGES + "red-arrow-up.png"
export const GREEN_UP_ARROW = IMAGES + "green-arrow-up.png"
export const RED_DOWN_ARROW = IMAGES + "red-arrow-down.png"

export const getArrowIcon = (project:number, currentState:number, isCost:boolean) => {

    if (project<currentState) return RED_DOWN_ARROW
    if (project>currentState) return GREEN_UP_ARROW

    return undefined
}

export function createUrlIcon(
  ctx: CanvasRenderingContext2D,
  url: string,
  imageSize: Size,
  iconSize: Size | null = null
): Promise<ImageData> {
  return new Promise((resolve, reject) => {
    const iconWidth = iconSize?.width || ctx.canvas.width
    const iconHeight = iconSize?.height || ctx.canvas.height
    // create an Image from the url
    const image = new Image(imageSize.width, imageSize.height)
    image.onload = () => {
      // render the image into the canvas
      ctx.clearRect(0, 0, iconWidth, iconHeight)
      ctx.drawImage(image, 0, 0, imageSize.width, imageSize.height, 0, 0, iconWidth, iconHeight)
      const imageData = ctx.getImageData(0, 0, iconWidth, iconHeight)
      resolve(imageData)
    }
    image.onerror = () => {
      reject('Loading the image failed.')
    }
    image.src = url
  })
}

/**
 * Creates a rendering context intended for creating the {@link ImageData} with the createXyzIcon
 * functions of this file.
 * The context has its willReadFrequently attribute set to true.
 */
export function createCanvasContext(width: number, height: number): CanvasRenderingContext2D {
  // canvas used to pre-render the icons
  const canvas = document.createElement('canvas')
  canvas.setAttribute('width', `${width}`)
  canvas.setAttribute('height', `${height}`)
  return canvas.getContext('2d', { willReadFrequently: true }) as CanvasRenderingContext2D
}
